import { Route } from '../model/route.model';

/**
 * Interface to replace the dependency on RouteParts from lib-global-model
 */
export interface IRouteParts {
  findMatch(routes: { [routePath: string]: Route | any }, routeParts: string | any[]): { route: any, param: any };
  toParts(parts: string | any[]): any[];
  toPath(route: Route, params: any): string;
  toString(parts: string | any[]): string;
}

/**
 * Implementation of RouteParts functionality
 */
export class RoutePartsUtil implements IRouteParts {
  
  findMatch(routes: { [routePath: string]: Route | any }, routeParts: string | any[]) {
    const commands = this.toParts(routeParts);
    const routeKeys = Object.keys(routes);
    const matches: any[] = [];

    for (const routeKey of routeKeys) {
      const route = routes[routeKey];
      const parts = this.toParts(routeKey);
      let match = true;
      const param = {};

      for (let i = 0; i < parts.length; i++) {
        const part = parts[i];
        if (commands.length < i - 1) {
          break;
        }

        // path is a variable
        if (part.substr(0, 1) === ':') {
          param[part.substr(1)] = commands[i];
          continue;

          // path is a variable
        } else if (part.substr(0, 2) === '/:') {
          param[part.substr(2)] = commands[i].substr(1);
          continue;

          // path should be the same
        } else {
          if (part !== commands[i]) {
            match = false;
            break;
          }
        }
      }

      if (match) {
        matches.push({ route, param, length: parts.length });
      }
    }

    if (matches.length) {
      const exactMatch = matches.find(match => match.route.path === routeParts);
      if (exactMatch) {
        return {
          route: exactMatch.route,
          param: exactMatch.param
        };
      } else {
        matches.sort((a, b) => a.length > b.length ? -1 : 1);
        if (matches[0]) {
          return {
            route: matches[0].route,
            param: matches[0].param,
          };
        }
      }
    }
    
    return null;
  }

  toParts(parts: string | any[]) {
    if (typeof parts === 'string') {
      parts = parts.split('/');
      parts.shift();
      parts[0] = `/${parts[0]}`;
    }
    return parts;
  }

  toPath(route: Route, params: any) {
    const items = this.toParts(route.path);
    for (let i = 0; i < items.length; i++) {
      if (items[i].substr(0, 1) === ':') {
        const key = items[i].substr(1);
        items[i] = params[key];
      }
    }
    return items.join('/');
  }

  toString(parts: string | any[]) {
    if (typeof parts === 'string') {
      return parts;
    }
    return parts.join('/');
  }
}

// Export a singleton instance for use throughout the application
export const RoutePartsInstance = new RoutePartsUtil();